import api from '../api';

import { ParamsBodySavePhoto } from 'utils/typeServices';

type ParamsResponse = {
    Data: any;
}

export const PostSavePhoto = async ({ token, body }: { token: string, body: ParamsBodySavePhoto }) => {
    let formData = new FormData();
    formData.append("foto", body.foto);

    try {
        await api.post<ParamsResponse>('/v1/Cliente/SavePhoto', formData, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'multipart/form-data'
            }
        });

        return { data: true };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
